import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosInstance } from '../../../utils/axios';

const API_URL = `api/v1/collections/sms-template/`;
const SLICE_NAME = 'configuracion';

export const fetchSmsTemplates = createAsyncThunk(`${SLICE_NAME}/fetchSmsTemplates`, async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(API_URL);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Error al obtener templates');
  }
});

export const createSmsTemplate = createAsyncThunk(
  `${SLICE_NAME}/createSmsTemplate`,
  async (templateData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(API_URL, templateData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error al crear template');
    }
  }
);

export const updateSmsTemplate = createAsyncThunk(
  `${SLICE_NAME}/updateSmsTemplate`,
  async ({ uuid, ...templateData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`${API_URL}${uuid}/`, templateData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error al editar template');
    }
  }
);

export const deleteSmsTemplate = createAsyncThunk(
  `${SLICE_NAME}/deleteSmsTemplate`,
  async ({ uuid }, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`${API_URL}${uuid}/`);
      return uuid;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error al eliminar template');
    }
  }
);

const smsTemplateSlice = createSlice({
  name: 'templates',
  initialState: {
    templates: {
      results: [],
      count: 0,
      page: 1,
      per_page: 50,
    },
    loading: false,
    error: null,
    operationSuccess: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Manejo del GET
      .addCase(fetchSmsTemplates.fulfilled, (state, action) => {
        state.loading = false;
        state.templates = action.payload;
      })
      // Manejo del POST
      .addCase(createSmsTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.createSuccess = true;
        if (state.templates.results) {
          state.templates.results.unshift(action.payload);
        }
      })
      //  Manejo del PUT
      .addCase(updateSmsTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;
        const index = state.templates.results.findIndex((template) => template.uuid === action.payload.uuid);
        if (index !== -1) {
          state.templates.results[index] = action.payload;
        }
      })
      // Manejo del DELETE
      .addCase(deleteSmsTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteSuccess = true;
        if (state.templates && Array.isArray(state.templates.results)) {
          state.templates.results = state.templates.results.filter((template) => template.uuid !== action.payload.uuid);
        }
      })
      // addMatcher para agrupar logica comun de estados
      .addMatcher(
        (action) => action.type.startsWith('configuracion/') && action.type.endsWith('/pending'),
        (state) => {
          state.loading = true;
          state.error = null;
          state.operationSuccess = false;
        }
      )
      .addMatcher(
        (action) => action.type.startsWith('configuracion/') && action.type.endsWith('/rejected'),
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        }
      );
  },
});

export default smsTemplateSlice.reducer;
